import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import CashSVG from '../../common/svgs/CashSVG';
import CardsSVG from '../../common/svgs/CardsSVG';
import LoyaltyIconSvg from '../../common/svgs/LoyaltyIconSVG';
import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import { loadPromotionSearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import CustomerInsightSearchOptions from '../customerInsightScreen/CustomerInsightSearchOptions';

class PromotionSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        promotionId: '',
        orderTypeId: '',
        paymentTypeId: '',
        discountTypeId: ''
    }

    componentDidMount() {
        const { restaurantId, customerId, maId } = this.props;
        this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, maId);
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId, maId } = this.props;
        this.setState({
            fromDate: searchOptionState.fromDate,
            toDate: searchOptionState.toDate,
            page: 0
        }, () => this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, maId, null,
            this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId));
    }

    handlePageChange = pageNumber => {
        const { restaurantId, customerId, maId } = this.props;
        this.setState({
            page: (pageNumber - 1)
        }, () => this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, maId, null,
            this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId));
    }

    renderProductSummaryTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.promoCode')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.date')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.totalAmount')}</th>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.orderType')}</th>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.paymentType')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.freeDelivery')}</th>
            </tr>
        );
    }

    renderTableContent = () => {
        return this.props.customerInsightPromotionSearch.content.map(item => {
            return this.renderSingleItem(item);
        })
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        
        return (
            <tr>
                <td style={{ ...tableDetail, ...textCenter }}>{item.promoCode ? item.promoCode : "-"}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.date}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{getPriceWithCurrencySymbol(item.discountAmount, currency)}</td>
                <td style={{ ...tableDetail }}>{this.renderOrderSVGIcon(item.orderType)}&nbsp;&nbsp;{this.renderOrderTypeName(item.orderType)}</td>
                <td style={{ ...tableDetail }}>{this.renderPaymentSVGIcon(item.paymentType)}&nbsp;&nbsp;{this.renderPaymentTypeName(item.paymentType)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.freeDelivery ? i18n.t('screens:customerInsightScreen.yes') : i18n.t('screens:customerInsightScreen.no')}</td>
            </tr>
        );
    }

    renderOrderSVGIcon = type => {
        switch (type) {
            case "Delivery": return <DeliverySVG width={16} height={16} fill={'#0288D1'} />;
            case "Collection": return <PickUpSVG width={16} height={16} fill={'#0288D1'} />
            case "Curbside": return <CurbsideSVG width={16} height={16} fill={'#0288D1'} />
            case "Dine In": return <InStoreSvg width={16} height={16} fill={'#0288D1'} />
            default: return null
        }
    }

    renderOrderTypeName = type => {
        switch (type) {
            case "Delivery": return i18n.t('screens:customerInsightScreen.Delivery');
            case "Collection": return i18n.t('screens:customerInsightScreen.Collection');
            case "Curbside": return i18n.t('screens:customerInsightScreen.Curbside');
            case "Dine In": return i18n.t(`screens:restaurantsMainContainer.instore`);
            default: return null
        }
    }

    renderPaymentSVGIcon = type => {
        switch (type) {
            case "Credit card": return <CardsSVG width={15} height={15} fill={'#0288D1'} />
            case "Cash": return <CashSVG width={15} height={15} fill={'#0288D1'} />
            case "Loyalty": return <LoyaltyIconSvg width={15} height={15} fill={'#0288D1'} />
            default: return null
        }
    }

    renderPaymentTypeName = type => {
        switch (type) {
            case "Credit card": return i18n.t('screens:customerInsightScreen.creditCard');
            case "Cash": return i18n.t('screens:customerInsightScreen.cash');
            case "Loyalty": return i18n.t('screens:customerInsightScreen.loyalty');
            default: return null
        }
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderOrderTypeDropdown()}
                    {this.renderPaymentTypeDropdown()}
                </Row>
            </Container>
        );
    }

    renderOrderTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="orderTypeId"
                    id="orderTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectOrderType')}
                    value={this.state.orderTypeId}
                    onChange={(e) => this.setState({ orderTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectOrderType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.Delivery')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.Collection')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.Curbside')}</option>
                    <option value='5'>{i18n.t(`screens:restaurantsMainContainer.instore`)}</option>
                </Input>
            </ Col>
        );
    }

    renderPaymentTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="paymentTypeId"
                    id="paymentTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectPaymentType')}
                    value={this.state.paymentTypeId}
                    onChange={(e) => this.setState({ paymentTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectPaymentType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.creditCard')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.cash')}</option>

                </Input>
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.customerInsightPromotionSearch.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.customerInsightPromotionSearch.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="PromotionSearch" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderProductSummaryTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightPromotionSearch: state.customerInsightPromotionSearch,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { loadPromotionSearch })(PromotionSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/UsedPromoCodesModal.js